<template>
  <div class="row pr-2">
    <div class="col eHabilitacao--border">
      <div class="row">
        <div class="col eHabilitacao--header pt-2 pb-2">
          <span class="Visualizador--fontHeader">
            E-Habilitação
          </span>
          <!--<span class="eHabilitacao&#45;&#45;cursor ml-4"
                @click="deleteDoc()">
            <icon-svg icon="trash"
                      class="icons&#45;&#45;red icon&#45;&#45;xs" />
          </span>-->
        </div>
      </div>
      <div class="row">
        <object v-if="propUrlPdf != null && show.pdf"
                class="document-preview embed-responsive"
                :data="`${ propUrlPdf }#page=${ propActualPage }`"
                type="application/pdf">
          <p>Seu browser não suporta arquivos pdf diretamente ou este arquivo não existe. Você pode tentar efetuar o download clicando.</p>
        </object>

        <div v-show="!propSequenciaDiff"
             class="document-preview embed-responsive block-leitor-pdf">
          <div class="text-center mt-5 pt-5">
            <h3>ATENÇÃO!</h3>
            <br>
            <p class="pl-5 pr-5">
              <b>A ordem dos documentos foi alterada.</b>
            </p>
            <br>
            Escolha uma ação abaixo:
            <div>
              <b-button class="mr-2"
                        variant="light"
                        @click="$emit('onRestore')">
                Manter ordem anterior
              </b-button>

              <b-button class="ml-2"
                        @click="$emit('onSaveOrdem')">
                Salvar ordem e Recarregar PDF
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Visualizador",
    props: {
      propSequenciaDiff: {
        type: Boolean,
        default: () => false
      },
      propUrlPdf: {
        type: String,
        default: () => null
      },
      propActualPage: {
        type: Number,
        default: () => 1
      }
    },
    data () {
      return {
        show: {
          pdf: true
        }
      }
    },
    watch: {
      propActualPage () {
        loader({ text: 'Carregando PDF...', active: true })
        this.show.pdf = false

        setTimeout(() => {
          this.show.pdf = true
          loader({ active: false })
        }, 500)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .Visualizador {
    &--fontHeader {
      font-size: 1.4em !important;
    }
  }
</style>

